import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAAZTgzIrqXk3GAw8InXYGsu6zOv-u6skk",
    authDomain: "offf-the-roast.firebaseapp.com",
    projectId: "offf-the-roast",
    storageBucket: "offf-the-roast.firebasestorage.app",
    messagingSenderId: "859198737354",
    appId: "1:859198737354:web:11e52a88c928ffd6081d33",
    measurementId: "G-M3GC9VYXV4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const functions = getFunctions(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, analytics, functions, db, storage };
export default app;
